module.exports = __webpack_public_path__ + "img/saloon-inside-v1-min.165690a9.jpg";